type Config = {
  ENV?: string;
  MYOB_ID_DOMAIN: string;
  CHECKOUT_AUTH0_CLIENT_ID: string;
  CHECKOUT_AUTH0_CLIENT_SOLO_ORGANIZATION: string;
  CHECKOUT_AUTH0_CLIENT_ID_DISABLED_EMAIL: string;
  API_BASE_URL: string;
  API_BASE_URL_AZURE: string;
  API_EXISTING_USER_CHECK: string;
  API_PRODUCT_PRICE_ENDPOINT: string;
  API_QUOTE_ENDPOINT: string;
  API_CONTENT_ENDPOINT: string;
  API_CHECKOUT_ENDPOINT_AUTH0: string;
  API_PURCHASE_ENDPOINT: string;
  API_CHECKOUT_ENDPOINT: string;
  API_QUOTE_CHECKOUT_ENDPOINT: string;
  API_ANNUAL_PURCHASE_ENDPOINT: string;
  API_TRIAL_ENDPOINT: string;
  API_CONTACTS_ENDPOINT: string;
  API_ACCOUNTS_ENDPOINT: string;
  API_PAYMENT_PROFILE_ENDPOINT: string;
  API_VALIDATE_BANK_CODE: string;
  API_RECAPTCHA_ENDPOINT: string;
  API_CREDIT_CARD_VALIDATION_ENDPOINT: string;
  BUY_BASE_URL: string;
  PRODUCT_URL: string;
  PARTNER_PROGRAM_PRODUCT_URL: string;
  PAYMENT_PCI_URL: string;
  CARD_PORTAL_PROXY_URL: string;
  BUY_BASE_HOST: string;
  WEBSITE_NZ: string;
  ONLINE_INVOICE_PAYMENTS: string;
  PAYROLL_ONLY: string;
  PREMIUM_FEATURES: string;
  PREMIUM_INVENTORY: string;
  FAIR_USE_POLICY_NZ: string;
  PARTNER_BUTTON_DISABLE_TIME: number;
  DEFAULT_BUTTON_DISABLE_TIME: number;
  SOLO_WEB_URL: string;
  SEGMENT_EVENT_ENDPOINT: string;
  NINETAILED_ENVIRONMENT: string;
  SENTRY_ENABLED: boolean;
  SENTRY_DSN: string;
  STRIPE_PUBLIC_KEY_AU: string;
  STRIPE_PUBLIC_KEY_NZ: string;
  API_PAYMENT_METHOD_ENDPOINT: string;
  SPLIT_API_KEY: string;
}

const configuration = {
  default: {
    BUY_BASE_HOST: 'buy.myob.com',
    API_BASE_URL: 'https://dxp-bettacart-bff-production.svc.platform.myob.com',
    API_BASE_URL_AZURE: 'https://dxp-bettacart-bff-production.svc.metis-prod.jupiter.myob.com',
    BUY_BASE_URL: 'https://buy.myob.com',
    API_EXISTING_USER_CHECK: '/existing-user',
    API_PRODUCT_PRICE_ENDPOINT: '/product-price',
    API_CONTACTS_ENDPOINT: '/contacts',
    API_PURCHASE_ENDPOINT: '/purchase',
    API_QUOTE_ENDPOINT: '/product-quote',
    API_QUOTE_CHECKOUT_ENDPOINT: '/quote-checkout',
    API_CHECKOUT_ENDPOINT: '/checkout-generic',
    API_CONTENT_ENDPOINT: '/content',
    // this is v2 ui connecting to v1 backend (workaround for annual purchase)
    API_ANNUAL_PURCHASE_ENDPOINT: '/checkout/annual/auth',
    API_TRIAL_ENDPOINT: '/trial',
    SEGMENT_EVENT_ENDPOINT: '/segment',
    API_ACCOUNTS_ENDPOINT: '/accounts',
    API_CHECKOUT_ENDPOINT_AUTH0: '/checkout/auth0',
    API_RECAPTCHA_ENDPOINT: '/recaptcha',
    API_PAYMENT_PROFILE_ENDPOINT: '/payment-profiles',
    API_VALIDATE_BANK_CODE: '/validate-bank-code',
    API_CREDIT_CARD_VALIDATION_ENDPOINT: '/validate-credit-card',
    CHECKOUT_AUTH0_CLIENT_ID: 'o0yogyeuy1iXoIhZoI2KyTXCplXC8mLy',
    CHECKOUT_AUTH0_CLIENT_SOLO_ORGANIZATION: 'org_yRd73qlIFnoIhILh',
    CHECKOUT_AUTH0_CLIENT_ID_DISABLED_EMAIL: 'uwEevNYrJkKSxB2uIpTRV3B2vIjXtzTr',
    PRODUCT_URL: 'https://app.myob.com/?ig#/businesses',
    PARTNER_PROGRAM_PRODUCT_URL: 'https://partner.myob.com/',
    PAYMENT_PCI_URL: 'https://pcicardportal.myob.com/portals/bettacartui/',
    CARD_PORTAL_PROXY_URL: 'https://pcicardportal.myob.com/proxy.html',
    MYOB_ID_DOMAIN: 'id.myob.com',
    WEBSITE_NZ: 'https://www.myob.com/nz',
    ONLINE_INVOICE_PAYMENTS: 'https://help.myob.com/wiki/display/myob/Online+invoice+payments#expand-IminAustralia',
    PAYROLL_ONLY: 'https://help.myob.com/wiki/display/myob/Payroll+limits+and+fees',
    PREMIUM_FEATURES: 'https://help.myob.com/wiki/display/GEN/MYOB+Premium+Features',
    PREMIUM_INVENTORY: 'https://help.myob.com/wiki/display/myob/Add+Premium+Inventory',
    FAIR_USE_POLICY_NZ: 'https://www.myob.com/nz/accounting-software/bankfeeds/myob-bankfeeds-fair-use-policy',
    PARTNER_BUTTON_DISABLE_TIME: 120000,
    DEFAULT_BUTTON_DISABLE_TIME: 60000,
    SOLO_WEB_URL: 'https://solo.myob.com',
    NINETAILED_ENVIRONMENT: 'development',
    SENTRY_ENABLED: false,
    // not a vulnerability
    // eslint-disable-next-line max-len
    // https://sentry.zendesk.com/hc/en-us/articles/26741783759899-My-DSN-key-is-publicly-visible-is-this-a-security-vulnerability
    SENTRY_DSN: 'https://86fb7d26e55c6d7fd332795b05bb9a9f@o39702.ingest.us.sentry.io/4508057248530432',
    STRIPE_PUBLIC_KEY_AU: 'pk_test_51Rtk1K7PWNzIGUZxLyDNXsDgjGoZg1Y1tTRgbmTS2F3DiQEW4gZE9Sf55Zy74qoeqd5i' +
      'bJz1dVii5rBCQXGKq6hG00gul9FYjU',
    STRIPE_PUBLIC_KEY_NZ: 'pk_test_51RtjuGGMrTjXEG1n72xpnoG7uAs5vuNiLC8ywoqFHZ2AYYttnTcAGAfaQuh3Qyde2gl' +
      'cmxmubtFJj0OFdTz9sxxY00yIFIvOK6',
    API_PAYMENT_METHOD_ENDPOINT: '/payment-method',
    SPLIT_API_KEY: 'sbkgfsiu9qjcfe210e1oq8mn72qvcvhvjd7m'
  },
  local: {
    API_BASE_URL: 'https://dxp-bettacart-bff-sit.svc.metis-preprod.jupiter.myobdev.com',
    API_BASE_URL_AZURE: 'https://dxp-bettacart-bff-sit.svc.metis-preprod.jupiter.myobdev.com',
    BUY_BASE_URL: 'http://localhost:3000',
    BUY_BASE_HOST: 'localhost',
    PAYMENT_PCI_URL: 'https://sit.pcicardportal.myob.com/portals/bettacartui/',
    PRODUCT_URL: 'https://pdv-sme-web.app.myobdev.com/?ig#/businesses',
    PARTNER_PROGRAM_PRODUCT_URL: 'https://shell.rogue.dev.myob.com/',
    CARD_PORTAL_PROXY_URL: 'https://sit.pcicardportal.myob.com/proxy.html',
    MYOB_ID_DOMAIN: 'sit.id.myob.com',
    API_PAYMENT_METHOD_ENDPOINT: '/payment-method',
    SOLO_WEB_URL: 'https://solo.myobdev.com'
  },
  sit: {
    BUY_BASE_URL: 'https://sit.buy.myob.com',
    BUY_BASE_HOST: 'sit.buy.myob.com',
    API_BASE_URL: 'https://dxp-bettacart-bff-sit.svc.metis-preprod.jupiter.myobdev.com',
    API_BASE_URL_AZURE: 'https://dxp-bettacart-bff-sit.svc.metis-preprod.jupiter.myobdev.com',
    PRODUCT_URL: 'https://pdv-sme-web.app.myobdev.com/?ig#/businesses',
    PARTNER_PROGRAM_PRODUCT_URL: 'https://shell.rogue.dev.myob.com/',
    PAYMENT_PCI_URL: 'https://sit.pcicardportal.myob.com/portals/bettacartui/',
    CARD_PORTAL_PROXY_URL: 'https://sit.pcicardportal.myob.com/proxy.html',
    MYOB_ID_DOMAIN: 'sit.id.myob.com',
    API_PAYMENT_METHOD_ENDPOINT: '/payment-method',
    SOLO_WEB_URL: 'https://solo.myobdev.com'
  },
  production: {
    CHECKOUT_AUTH0_CLIENT_SOLO_ORGANIZATION: 'org_rQWG87QFrqbBOEGf',
    CHECKOUT_AUTH0_CLIENT_ID: 'XjafHfncbwGQIyrto053V6WLKocNfSvr',
    CHECKOUT_AUTH0_CLIENT_ID_DISABLED_EMAIL: 'SUhP8NEigDRS4rRkKLnrV1jjO5PQUKvb',
    NINETAILED_ENVIRONMENT: 'main',
    SENTRY_ENABLED: true,
    STRIPE_PUBLIC_KEY_AU: 'pk_live_51Rtk1C7Im8bKenMYyFK6SKwvIsBdksHItjd6BvJYXgmZ7lgbKIFD2x' +
      'ZCue6FRieLhkCYsInZZLyWGL1SmZ46d2eR00DAESBuYC',
    STRIPE_PUBLIC_KEY_NZ: 'pk_live_51Rtju7GO4PVs2fbMhPvJ0f271kA1itXE7MX6mos58KjAAung9UPdxQ' +
      'bdB9YUSwMQtoETkIg5EDdkDZPNN7KybEi300Kj2O1p94',
    SPLIT_API_KEY: 'tkdevjajdutmh0th6tvmriv6crp0eo715h'
  }
};

const config: Config =
  Object.assign(configuration.default, configuration[process.env.REACT_APP_STAGE]);

export default config;
